let allItems = {
    documentationLink: [],
    faq: [],
    article: [],
    page: [],
    helpSearch: []
};
let activeTab = 'documentation'; 


async function helpSearch(searchText) {
    const url = new URL('https://apiapi.ombligo.com/helpSearch');

    url.searchParams.append('query', searchText);

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    const data = await response.json();
    if (data.results && data.results.length > 0) {
        allItems.helpSearch = data.results;
        return data.results;
    } else {
        console.error('Invalid help search data format:', data);
        return [];
    }
}

function getResourceURL(url) {
    const urlParts = url.split('.');
    const lastPart = urlParts[urlParts.length - 1].toLowerCase();
    if (lastPart === 'pdf') { 
        let resp = "https://onlineimages.techmikeny.com/CTOPDF/" + url;
        return resp;
    } else if (lastPart === 'txt') {
        let resp = "https://techmikeny.com/blogs/techtalk/" + urlParts[0];
        return resp;
    }
    return url;
}

function prettyPrint(text, deliminator) {
    const textParts = text.split(deliminator);
    const formattedText = textParts.map(part => {
        let trimmedPart = part.trim();
        if (trimmedPart.length > 0) {
            trimmedPart = trimmedPart.charAt(0).toUpperCase() + trimmedPart.slice(1);
        }
        return trimmedPart;
    });
    return formattedText.join(' ').replaceAll('_', ' ').replaceAll('-', ' ');
}



function getResourceTitle(source) {
    const sourceParts = source.split('.');
    const lastPart = sourceParts[sourceParts.length - 1].toLowerCase();
    if (lastPart === 'pdf') { 
        let found = "";
        allItems.documentationLink.forEach(item => {
            if (item.fields.linkUrl.toLowerCase().includes(source.toLowerCase())) {
                found = item.fields.title;
            }
        });
        if (found === "") {
            found = prettyPrint(sourceParts[0], '-');
        }
        return found;

    } else if (lastPart === 'txt') {
        return prettyPrint(sourceParts[0], '-');
    }
}

function createHelpSearchCard(item, i) {



    const card = document.createElement('div');
    card.className = 'documentation-card help-search-card';
    card.setAttribute("style", `--i: ${i};`);
    card.id = `help-search-card-${encodeURIComponent(item.source)}`;
    
    card.dataset.title = item.source ? item.source.toLowerCase() : '';
    card.dataset.content = item.chunk ? item.chunk.toLowerCase() : '';
    
    const helpContent = document.createElement('div');
    helpContent.className = 'help-content';
    
    const textContainer = document.createElement('div');
    textContainer.className = 'help-text';
    
    const title = document.createElement('h3');
    title.textContent = getResourceTitle(item.source);


    const content = document.createElement('div');
    content.className = 'help-excerpt';
    content.innerHTML = item.chunk || item.chunk || 'View this help resource for more information';
    
    const viewButton = document.createElement('a');
    viewButton.className = 'help-link';
    let text = 'View Resource';
    viewButton.innerHTML = `${text} <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff" style="margin-left:2%;"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg>`;

    viewButton.href = getResourceURL(item.source);
    viewButton.target = '_blank';
    
    textContainer.appendChild(title);
    textContainer.appendChild(content);
    textContainer.appendChild(viewButton);
    
    helpContent.appendChild(textContainer);
    
    card.appendChild(helpContent);
    
    card.addEventListener('click', (e) => {
        if (!e.target.classList.contains('help-link')) {
            window.open(getResourceURL(item.source), '_blank').focus();
        }
    });
    
    return [card, card.id];
}

function initializeHelpSearchUI() {
    const helpSearchGrid = document.createElement('div');
    helpSearchGrid.id = 'help-search-grid';
    helpSearchGrid.className = 'article-grid';
    helpSearchGrid.style.display = 'none';
    
    const documentationContainer = document.querySelector('.documentation-container');
    
    // Insert help search grid after page grid or at the end
    if (!document.getElementById('help-search-grid') && document.getElementById('page-grid')) {
        documentationContainer.insertBefore(helpSearchGrid, document.getElementById('page-grid').nextSibling);
    } else if (!document.getElementById('help-search-grid')) {
        documentationContainer.appendChild(helpSearchGrid);
    }
}



async function searchPages(searchText){
    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';
    const graphqlQuery = `
        query pagesQuery {
            pages(first: 10, query: "${searchText}") {
                nodes {
                    title
                    onlineStoreUrl
                    seo {
                        description
                    }
                }
            }
        }
    `;

    try {
        const response = await fetch(`https://${domain}/api/2025-04/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query: graphqlQuery }),
        });
        
        const data = await response.json();
        
        if (data && data.data && data.data.pages && data.data.pages.nodes) {
            return data.data.pages.nodes;
        } else {
            console.error('Invalid page data format:', data);
            return [];
        }
    } catch (error) {
        console.error('Error fetching pages:', error);
        return [];
    }
}

function createPageCard(item, i) {
    const isWarranty = item.title && item.title.toLowerCase().includes('warranty');
    const card = document.createElement('div');
    card.className = 'documentation-card page-card';
    card.setAttribute("style", `--i: ${i};`);
    
    card.dataset.title = item.title ? item.title.toLowerCase() : '';
    card.dataset.description = item.seo && item.seo.description ? item.seo.description.toLowerCase() : '';
    
    const pageContent = document.createElement('div');
    pageContent.className = 'page-content';
    
    const textContainer = document.createElement('div');
    textContainer.className = 'page-text';
    
    const title = document.createElement('h3');
    title.textContent = item.title;

    const description = document.createElement('div');
    description.className = 'page-description';
    if (item.seo && item.seo.description) {
        description.textContent = item.seo.description;
    } else {
        description.textContent = 'View this page for more information';
    }
    
    const viewButton = document.createElement('a');
    viewButton.className = 'page-link';
    viewButton.textContent = 'View Page';
    viewButton.href = item.onlineStoreUrl;
    viewButton.target = '_blank';
    
    textContainer.appendChild(title);
    textContainer.appendChild(description);
    textContainer.appendChild(viewButton);
    
    pageContent.appendChild(textContainer);
    
    card.appendChild(pageContent);
    
    card.addEventListener('click', (e) => {
        if (!e.target.classList.contains('page-link')) {
            window.open(item.onlineStoreUrl, '_blank').focus();
        }
    });
    
    return [card, isWarranty];
}

function initializePageUI() {
    const pageGrid = document.createElement('div');
    pageGrid.id = 'page-grid';
    pageGrid.className = 'article-grid';
    pageGrid.style.display = 'none';
    
    const documentationContainer = document.querySelector('.documentation-container');
    
    // Insert page grid after article grid
    if (!document.getElementById('page-grid') && document.getElementById('article-grid')) {
        documentationContainer.insertBefore(pageGrid, document.getElementById('article-grid').nextSibling);
    } else if (!document.getElementById('page-grid')) {
        documentationContainer.appendChild(pageGrid);
    }
}


async function searchArticles(searchText) {
    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';
    const graphqlQuery = `
        query articleQuery {
            articles(query: "${searchText}", first: 10) {
                edges {
                    node {
                        content(truncateAt: 350)
                        onlineStoreUrl
                        title
                        publishedAt
                        image {
                            src
                            altText
                        }
                    }
                }
            }
        }
    `;

    try {
        const response = await fetch(`https://${domain}/api/2025-04/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query: graphqlQuery }),
        });
        
        const data = await response.json();
        
        if (data && data.data && data.data.articles && data.data.articles.edges) {
            return data.data.articles.edges;
        } else {
            console.error('Invalid article data format:', data);
            return [];
        }
    } catch (error) {
        console.error('Error fetching articles:', error);
        return [];
    }
}


function createArticleCard(item, i) {
    const card = document.createElement('div');
    card.className = 'documentation-card article-card';
    card.setAttribute("style", `--i: ${i};`);
    
    card.dataset.title = item.node.title ? item.node.title.toLowerCase() : '';
    card.dataset.content = item.node.content ? item.node.content.toLowerCase() : '';
    
    const articleContent = document.createElement('div');
    articleContent.className = 'article-content';
    
    const imageContainer = document.createElement('div');
    imageContainer.className = 'article-image';
    
    if (item.node.image && item.node.image.src) {
        const img = document.createElement('img');
        img.src = item.node.image.src;
        img.alt = item.node.image.altText || item.node.title;
        imageContainer.appendChild(img);
    } else {
        imageContainer.classList.add('no-image');
    }
    
    const textContainer = document.createElement('div');
    textContainer.className = 'article-text';
    
    const title = document.createElement('h3');
    title.textContent = item.node.title;

    const publishedAt = document.createElement('div');
    publishedAt.className = 'article-excerpt';
    publishedAt.innerHTML = new Date(item.node.publishedAt).toDateString();

    const content = document.createElement('div');
    content.className = 'article-excerpt';
    content.innerHTML = item.node.content;
    
    const viewButton = document.createElement('a');
    viewButton.className = 'article-link';
    viewButton.textContent = 'Read Article';
    viewButton.href = item.node.onlineStoreUrl;
    viewButton.target = '_blank';
    
    textContainer.appendChild(title);
    textContainer.appendChild(publishedAt);
    textContainer.appendChild(content);
    textContainer.appendChild(viewButton);
    
    articleContent.appendChild(imageContainer);
    articleContent.appendChild(textContainer);
    
    card.appendChild(articleContent);
    
    card.addEventListener('click', (e) => {
        if (!e.target.classList.contains('article-link')) {
            window.open(item.node.onlineStoreUrl, '_blank').focus();
        }
    });
    
    return card;
}

function initializeArticleUI() {
    const articleGrid = document.createElement('div');
    articleGrid.id = 'article-grid';
    articleGrid.className = 'article-grid';
    articleGrid.style.display = 'none';
    
    const documentationContainer = document.querySelector('.documentation-container');
    
    // Insert article grid after FAQ grid
    if (!document.getElementById('article-grid') && document.getElementById('faq-grid')) {
        documentationContainer.insertBefore(articleGrid, document.getElementById('faq-grid').nextSibling);
    } else if (!document.getElementById('article-grid')) {
        documentationContainer.appendChild(articleGrid);
    }
}




function createDocumentationCard(item, i) {
    const isMobile = window.innerWidth <= 768;
    const card = document.createElement('div');
    card.className = 'documentation-card';
    card.setAttribute("style", `--i: ${i};`);
    card.dataset.title = item.fields.title.toLowerCase();
    card.dataset.url = item.fields.linkUrl;
    
    if (item.fields.category) {
        card.dataset.category = Array.isArray(item.fields.category) 
            ? item.fields.category.join(',').toLowerCase()
            : item.fields.category.toLowerCase();
    }
    
    if (item.fields.type) {
        card.dataset.type = Array.isArray(item.fields.type)
            ? item.fields.type.join(',').toLowerCase()
            : item.fields.type.toLowerCase();
    }
    
    const title = document.createElement('h3');
    title.textContent = item.fields.title;
    
    const viewButton = document.createElement('a');
    viewButton.className = 'documentation-link-button';
    if (isMobile || !item.fields.linkUrl.includes('onlineimages')) {
        viewButton.style.width = "75%";
        let text = 'View Resource';
        if (!isMobile) text = 'View External Resource';
        viewButton.innerHTML = `${text} <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff" style="margin-left:2%;"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg>`;
        viewButton.addEventListener('click', () => {
            window.open(item.fields.linkUrl, '_blank').focus();
        });
    } else {
        viewButton.textContent = 'View Resource';
        viewButton.addEventListener('click', () => {
            showDocumentationInIframe(item.fields.linkUrl, item.fields.title);
        });
    }
    
    card.appendChild(title);
    card.appendChild(viewButton);
    
    return card;
}

function createFaqCard(item, i) {
    const card = document.createElement('div');
    card.className = 'documentation-card faq-card';
    card.setAttribute("style", `--i: ${i};`);
    
    card.dataset.title = item.fields.title ? item.fields.title.toLowerCase() : '';

    if (item.fields.category && item.fields.category.length > 0) {
        card.dataset.category = item.fields.category.join(',').toLowerCase();
    }
    
    if (item.fields.model && item.fields.model.length > 0) {
        card.dataset.model = item.fields.model.join(',').toLowerCase();
    }
    
    const title = document.createElement('h3');
    title.textContent = item.fields.title || 'FAQ';

    
    const answer = document.createElement('div');
    answer.className = 'faq-answer';
    answer.innerHTML = parseRichText(item.fields.answer);
    
    
    card.appendChild(title);
    card.appendChild(answer);
    
    return card;
}


function showDocumentationInIframe(url, title) {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        window.open(url, '_blank').focus();
        return;
    }
    const iframe = document.getElementById('documentation-iframe');
    const container = document.getElementById('documentation-iframe-container');
    const contentGrid = document.getElementById(`documentationLink-grid`);
    const faqContainer = document.getElementById('faq-grid');
    const sectionTitle = document.querySelector('#docTab');
    const faqTitle = document.querySelector('#faqTab');
    const openInNewPageButton = document.getElementById('open-iframe');
    
    iframe.src = url;
    openInNewPageButton.dataset.url = url;
    
    container.style.display = 'block';

    sectionTitle.innerText = title;

    container.scrollIntoView();
}


const DELL_MODEL_REGEX = /\bR(\d{0,4})\b/i;  // Matches R followed by up to \4 digits
const HP_MODEL_REGEX = /\bDL(\d{0,3})\b/i;   // Matches DL followed by uop to 3 digits


function calculateModelSimilarity(queryModel, resultModel) {
    const dellQueryMatch = queryModel.match(DELL_MODEL_REGEX);
    const hpQueryMatch = queryModel.match(HP_MODEL_REGEX);
    const dellResultMatch = resultModel.match(DELL_MODEL_REGEX);
    const hpResultMatch = resultModel.match(HP_MODEL_REGEX);
  
    if (dellQueryMatch && dellResultMatch) {
      const queryNumber = parseInt(dellQueryMatch[1], 10);
      const resultNumber = parseInt(dellResultMatch[1], 10);
      return calculateNumericSimilarity(queryNumber, resultNumber);
    }
  
    if (hpQueryMatch && hpResultMatch) {
      const queryNumber = parseInt(hpQueryMatch[1], 10);
      const resultNumber = parseInt(hpResultMatch[1], 10);
      return calculateNumericSimilarity(queryNumber, resultNumber);
    }
  
    return 0;
  }
  
  function calculateNumericSimilarity(queryNumber, resultNumber) {
    const MAX_RELEVANT_DIFFERENCE = 100;
    const difference = Math.abs(queryNumber - resultNumber);
    if (difference === 0) return 100;
    if (difference <= MAX_RELEVANT_DIFFERENCE) {
      return 100 - (difference / MAX_RELEVANT_DIFFERENCE * 100);
    }
    return 0;
  }


  function createEmptySectionMessage(type, container) {
    const emptyState = document.createElement('div');
    emptyState.className = 'empty-section-message';
    emptyState.textContent = `No matching ${type} found for your search.`;
      
    const clearSearchButton = document.createElement('button');

    clearSearchButton.id = 'clear-search';
    clearSearchButton.innerHTML = 'Clear search';
    clearSearchButton.title = 'Clear search';
    clearSearchButton.style.background = '#00243ff7';
    clearSearchButton.style.color = "white";
    clearSearchButton.style.padding = "2px 10px";
    clearSearchButton.style.borderRadius = '4px';
    clearSearchButton.style.border = 'none';
    clearSearchButton.style.fontSize = '18px';
    clearSearchButton.style.cursor = 'pointer';
    clearSearchButton.style.maxWidth = '200px';
    
    
    clearSearchButton.addEventListener('click', () => {
        const url = new URL(window.location.href);
        const searchInput = document.getElementById('search-input');
        url.searchParams.delete("q");
        window.history.pushState({}, '', url);
        searchInput.value = '';
        clearSearchButton.style.display = 'none';
        document.getElementById('seenWarrantyContainer').innerHTML = '';
        displayContent('faq');
        displayContent('documentationLink');
        filterCards('');
    });     
    container.appendChild(emptyState);
   
    container.appendChild(clearSearchButton);

}
  

  function filterCards(searchText) {
    const documentationGrid = document.getElementById('documentationLink-grid');
    const faqGrid = document.getElementById('faq-grid');
    const articleGrid = document.getElementById('article-grid');
    const pageGrid = document.getElementById('page-grid');  // Added page grid
    const helpSearchGrid = document.getElementById('help-search-grid');

    const iframeContainer = document.getElementById('documentation-iframe-container');
    
    const existingShowMoreContainers = document.querySelectorAll('.show-more-container');
    existingShowMoreContainers.forEach(container => container.remove());
    
    const docResultsHeader = document.getElementById('doc-results-header') || createResultsHeader('doc-results-header', 'Documentation Results');
    const faqResultsHeader = document.getElementById('faq-results-header') || createResultsHeader('faq-results-header', 'FAQ Results');
    const articleResultsHeader = document.getElementById('article-results-header') || createResultsHeader('article-results-header', 'Article Results');
    const helpResultsHeader = document.getElementById('help-results-header') || createResultsHeader('help-results-header', 'Quick Help Results');

    const pageResultsHeader = document.getElementById('page-results-header') || createResultsHeader('page-results-header', 'Page Results');  // Added page results header
    
    if (!document.getElementById('doc-results-header')) {
        documentationGrid.parentNode.insertBefore(docResultsHeader, documentationGrid);
    }
    
    if (!document.getElementById('faq-results-header')) {
        faqGrid.parentNode.insertBefore(faqResultsHeader, faqGrid);
    }
    
    if (!document.getElementById('article-results-header')) {
        articleGrid.parentNode.insertBefore(articleResultsHeader, articleGrid);
    }
    
    if (!document.getElementById('page-results-header')) {
        pageGrid.parentNode.insertBefore(pageResultsHeader, pageGrid);  // Added page results header
    }
    
    if (!document.getElementById('help-results-header')) {
        helpSearchGrid.parentNode.insertBefore(helpResultsHeader, helpSearchGrid);
    }
    
    let searchState = {
        isSearching: false,
        hasDocResults: false,
        hasFaqResults: false,
        hasArticleResults: false,
        hasPageResults: false,  
        hasHelpResults: false,
        totalResults: 0
    };
    
    const existingNoResults = document.getElementById('no-results-message');
    if (existingNoResults) existingNoResults.style.display = 'none';
    
    if (searchText.trim() === '') {
        documentationGrid.style.display = activeTab === 'documentation' ? 'grid' : 'none';
        faqGrid.style.display = activeTab === 'faq' ? 'grid' : 'none';
        articleGrid.style.display = 'none';
        pageGrid.style.display = 'none';  // Hide page grid when no search
        helpSearchGrid.style.display = 'none';
        
        if (docResultsHeader) docResultsHeader.style.display = 'none';
        if (faqResultsHeader) faqResultsHeader.style.display = 'none';
        if (articleResultsHeader) articleResultsHeader.style.display = 'none';
        if (pageResultsHeader) pageResultsHeader.style.display = 'none';  // Hide page header when no search
        if (helpResultsHeader) helpResultsHeader.style.display = 'none';
        
        if (activeTab === 'documentation') {
            document.getElementById('brandContainer').style.display = 'flex';
            document.getElementById('typeContainer').style.display = 'flex';
            document.getElementById('faqCategoryContainer').style.display = 'none';
            document.getElementById('faqModelContainer').style.display = 'none';

        } else {
            document.getElementById('brandContainer').style.display = 'none';
            document.getElementById('typeContainer').style.display = 'none';
            document.getElementById('faqCategoryContainer').style.display = 'flex';
            document.getElementById('faqModelContainer').style.display = 'flex';
        }
        
        return;
    }
    
    searchState.isSearching = true;
    
    document.getElementById('brandContainer').style.display = 'none';
    document.getElementById('typeContainer').style.display = 'none';
    document.getElementById('faqCategoryContainer').style.display = 'none';
    document.getElementById('faqModelContainer').style.display = 'none';
    
    documentationGrid.style.display = 'grid';
    faqGrid.style.display = 'grid';
    articleGrid.style.display = 'grid';
    pageGrid.style.display = 'grid';  // Show page grid during search
    helpSearchGrid.style.display = 'grid';

    iframeContainer.style.display = 'none';
    
    documentationGrid.innerHTML = '<div class="loading">Searching documentation...</div>';
    faqGrid.innerHTML = '<div class="loading">Searching FAQs...</div>';
    articleGrid.innerHTML = '<div class="loading">Searching articles...</div>';
    pageGrid.innerHTML = '<div class="loading">Searching pages...</div>';  // Added loading indicator for pages
    helpSearchGrid.innerHTML = '<div class="loading">Searching help resources...</div>';
    

    const searchTermsRaw = searchText.toLowerCase().split(' ');
    const searchTerms = searchTermsRaw.filter(term => term.length > 0);
    
    
    const docMatches = [];
    
    let queryModel = '';

    for (const term of searchTerms) {
        if (DELL_MODEL_REGEX.test(term) || HP_MODEL_REGEX.test(term)) {
            queryModel = term;
            break;
        }
    }


    if (allItems.documentationLink && allItems.documentationLink.length > 0) {
        allItems.documentationLink.forEach(item => {
            let searchableText = item.fields.title ? item.fields.title.toLowerCase() : '';
            
            if (item.fields.category) {
                if (Array.isArray(item.fields.category)) {
                    searchableText += ' ' + item.fields.category.join(' ').toLowerCase();
                } else {
                    searchableText += ' ' + item.fields.category.toLowerCase();
                }
            }
            
            if (item.fields.type) {
                if (Array.isArray(item.fields.type)) {
                    searchableText += ' ' + item.fields.type.join(' ').toLowerCase();
                } else {
                    searchableText += ' ' + item.fields.type.toLowerCase();
                }
            }
            
            let matchCount = 0;
            searchTerms.forEach(term => {
                if (searchableText.includes(term)) matchCount++;
            });
            
            let modelSimilarityBoost = 0;
            
            if (queryModel) {
                const modelMatch = searchableText.match(DELL_MODEL_REGEX) || searchableText.match(HP_MODEL_REGEX);
                if (modelMatch) {
                    const resultModel = modelMatch[0];
                    modelSimilarityBoost = calculateModelSimilarity(queryModel, resultModel);
                }
            }
            

            const relevance = matchCount + (modelSimilarityBoost / 100);
            
            if (relevance > 0) {
                docMatches.push({ 
                    item: item, 
                    relevance: relevance,
                    _debug: {
                        termMatches: matchCount,
                        modelBoost: modelSimilarityBoost
                    }
                });
            }
        });
        docMatches.sort((a, b) => b.relevance - a.relevance);

    }
    
    
    const faqMatches = [];
    
    if (allItems.faq && allItems.faq.length > 0) {
        allItems.faq.forEach(item => {
            let searchableText = item.fields.title ? item.fields.title.toLowerCase() : '';
            
            if (item.fields.category && item.fields.category.length > 0) {
                searchableText += ' ' + item.fields.category.join(' ').toLowerCase();
            }
            
            if (item.fields.model && item.fields.model.length > 0) {
                searchableText += ' ' + item.fields.model.join(' ').toLowerCase();
            }
            
            if (item.fields.answer) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = parseRichText(item.fields.answer);
                searchableText += ' ' + tempDiv.textContent.toLowerCase();
            }
            
            let matchCount = 0;
            searchTerms.forEach(term => {
                if (searchableText.includes(term)) matchCount++;
            });
            
            if (matchCount > 0) {
                faqMatches.push({ item: item, relevance: matchCount });
            }
        });
    }
    
    docMatches.sort((a, b) => b.relevance - a.relevance);
    faqMatches.sort((a, b) => b.relevance - a.relevance);
    
    searchState.hasDocResults = docMatches.length > 0;
    searchState.hasFaqResults = faqMatches.length > 0;
    searchState.totalResults += docMatches.length + faqMatches.length;
    
    docResultsHeader.textContent = `Documentation Results (${docMatches.length})`;
    faqResultsHeader.textContent = `FAQ Results (${faqMatches.length})`;
    
    docResultsHeader.style.display = 'block';
    faqResultsHeader.style.display = 'block';
    
    documentationGrid.innerHTML = '';
    if (docMatches.length > 0) {
        const initialLimit = Math.min(25, docMatches.length);
        
        docMatches.slice(0, initialLimit).forEach((match, i) => {
            const card = createDocumentationCard(match.item, i + 1);
            documentationGrid.appendChild(card);
        });
        
        if (docMatches.length > initialLimit) {
            addShowMoreButton(documentationGrid, 'doc', initialLimit, docMatches.length, docMatches.map(match => match.item));
        }
    } else {
        createEmptySectionMessage('documentation', documentationGrid);

    }
    
    faqGrid.innerHTML = '';
    if (faqMatches.length > 0) {
        const initialLimit = Math.min(25, faqMatches.length);
        
        faqMatches.slice(0, initialLimit).forEach((match, i) => {
            const card = createFaqCard(match.item, i + 1);
            faqGrid.appendChild(card);
        });
        
        if (faqMatches.length > initialLimit) {
            addShowMoreButton(faqGrid, 'faq', initialLimit, faqMatches.length, faqMatches.map(match => match.item));
        }
    } else {

        createEmptySectionMessage('faq', faqGrid);


    }
    
    searchArticles(searchText).then(articles => {
        articleGrid.innerHTML = '';
        
        if (articles.length > 0) {
            searchState.hasArticleResults = true;
            searchState.totalResults += articles.length;
            
            articles = articles.sort((a, b) => {
                return new Date(b.node.publishedAt) - new Date(a.node.publishedAt);
            });
            
            const initialLimit = 25;
            const totalArticles = articles.length;
            const needsShowMore = totalArticles > initialLimit;
            
            articles.slice(0, initialLimit).forEach((article, i) => {
                const card = createArticleCard(article, i);
                articleGrid.appendChild(card);
            });
            
            if (needsShowMore) {
                addShowMoreButton(articleGrid, 'article', initialLimit, totalArticles, articles);
            }
            
            articleResultsHeader.textContent = `Article Results (${articles.length})`;
            articleResultsHeader.style.display = 'block';
            articleGrid.style.display = 'grid';
        } else {
            articleResultsHeader.textContent = 'Article Results (0)';
            articleResultsHeader.style.display = 'block';

            createEmptySectionMessage('article', articleGrid);
            
        }
        
        checkForNoResults(searchState);
    }).catch(error => {
        console.error('Error fetching articles:', error);
        
        articleGrid.innerHTML = '';
        const errorMessage = document.createElement('div');
        errorMessage.className = 'error-message';
        errorMessage.textContent = 'Error fetching article results. Please try again.';
        articleGrid.appendChild(errorMessage);
        
        checkForNoResults(searchState);
    });

    searchPages(searchText).then(pages => {
        let seenWarranty = false;
        pageGrid.innerHTML = '';
        
        if (pages && pages.length > 0) {
            searchState.hasPageResults = true;
            searchState.totalResults += pages.length;
            
            const initialLimit = 25;
            const totalPages = pages.length;
            const needsShowMore = totalPages > initialLimit;
            
            pages.slice(0, initialLimit).forEach((page, i) => {
                const [card, isWarranty] = createPageCard(page, i);
                if (isWarranty) {
                    seenWarranty = true;
                }
                pageGrid.appendChild(card);
            });
            
            if (needsShowMore) {
                addShowMoreButton(pageGrid, 'page', initialLimit, totalPages, pages);
            }
            
            pageResultsHeader.textContent = `Page Results (${pages.length})`;
            pageResultsHeader.style.display = 'block';
            pageGrid.style.display = 'grid';
            if (seenWarranty) {
                let pageGridClone = pageGrid.cloneNode(true);
                let pageGridTitleClone = pageResultsHeader.cloneNode(true);
                let seenWarrantyContainer = document.getElementById('seenWarrantyContainer');
                seenWarrantyContainer.innerHTML = '';
                seenWarrantyContainer.appendChild(pageGridTitleClone);
                seenWarrantyContainer.appendChild(pageGridClone);
                
            }

        } else {
            pageResultsHeader.textContent = 'Page Results (0)';
            pageResultsHeader.style.display = 'block';
            
            createEmptySectionMessage('page', pageGrid);


        }
        
        checkForNoResults(searchState);
    }).catch(error => {
        console.error('Error fetching pages:', error);
        
        pageGrid.innerHTML = '';
        const errorMessage = document.createElement('div');
        errorMessage.className = 'error-message';
        errorMessage.textContent = 'Error fetching page results. Please try again.';
        pageGrid.appendChild(errorMessage);
        
        checkForNoResults(searchState);
    });

     
    helpSearch(searchText).then(pages => {
        helpSearchGrid.innerHTML = '';
        let renderedResults = 0;    
        if (pages && pages.length > 0) {
            searchState.hasPageResults = true;
            searchState.totalResults += pages.length;
            
            const initialLimit = 25;
            const totalPages = pages.length;
            const needsShowMore = totalPages > initialLimit;
            
            pages.slice(0, initialLimit).forEach((page, i) => {
                const [card, cardid] = createHelpSearchCard(page, i);
                if (!document.getElementById(cardid)) {
                    helpSearchGrid.appendChild(card);
                    renderedResults++;
                }
            });
            
            if (needsShowMore) {
                addShowMoreButton(helpSearchGrid, 'page', initialLimit, totalPages, pages);
            }
            
            helpResultsHeader.textContent = `Quick Help Results (${renderedResults})`;
            pageResultsHeader.style.display = 'block';
            helpSearchGrid.style.display = 'grid';
        } else {
            pageResultsHeader.textContent = 'Page Results (0)';
            pageResultsHeader.style.display = 'block';
            
            createEmptySectionMessage('page', helpSearchGrid);


        }
        
        checkForNoResults(searchState);
    }).catch(error => {
        console.error('Error fetching pages:', error);
        
        helpSearchGrid.innerHTML = '';
        const errorMessage = document.createElement('div');
        errorMessage.className = 'error-message';
        errorMessage.textContent = 'Error fetching page results. Please try again.';
        helpSearchGrid.appendChild(errorMessage);
        
        checkForNoResults(searchState);
    });
    
    checkForNoResults(searchState);
}


function checkForNoResults(searchState) {
    const hasNoResults = searchState.isSearching && 
                       !searchState.hasDocResults && 
                       !searchState.hasFaqResults && 
                       !searchState.hasArticleResults &&
                       !searchState.hasPageResults;  
    
    const noResultsMsg = document.getElementById('no-results-message') || createNoResultsMessage();
    
    if (hasNoResults) {
        if (!document.getElementById('no-results-message')) {
            const documentationGrid = document.getElementById('documentationLink-grid');
            documentationGrid.parentNode.insertBefore(noResultsMsg, documentationGrid);
        }
        noResultsMsg.style.display = 'block';
    } else {
        noResultsMsg.style.display = 'none';
    }
}




function addShowMoreButton(container, type, currentShown, total, items) {
    const existingShowMore = container.querySelector('.show-more-container');
    if (existingShowMore) {
        existingShowMore.remove();
    }
    
    const showMoreContainer = document.createElement('div');
    showMoreContainer.className = 'show-more-container';
    
    const showMoreButton = document.createElement('button');
    showMoreButton.className = 'show-more-button';
    showMoreButton.textContent = `Show More (${currentShown} of ${total})`;
    showMoreButton.dataset.currentShown = currentShown;
    showMoreButton.dataset.total = total;
    
    showMoreButton.addEventListener('click', function() {
        const batchSize = 25;
        const currentShownValue = parseInt(this.dataset.currentShown);
        const totalValue = parseInt(this.dataset.total);
        const nextBatch = Math.min(currentShownValue + batchSize, totalValue);
        
        container.removeChild(showMoreContainer);
        
        items.slice(currentShownValue, nextBatch).forEach((item, index) => {
            let card;
            
            if (type === 'article') {
                card = createArticleCard(item, currentShownValue + index);
            } else if (type === 'doc') {
                card = createDocumentationCard(item, currentShownValue + index + 1);
            } else if (type === 'faq') {
                card = createFaqCard(item, currentShownValue + index + 1);
            }
            
            if (card) {
                container.appendChild(card);
            }
        });
        
        this.textContent = `Show More (${nextBatch} of ${totalValue})`;
        this.dataset.currentShown = nextBatch;
        
        if (nextBatch < totalValue) {
            container.appendChild(showMoreContainer);
        }
    });
    
    showMoreContainer.appendChild(showMoreButton);
    container.appendChild(showMoreContainer);
}

function createResultsHeader(id, text) {
    const header = document.createElement('h2');
    header.id = id;
    header.className = 'results-section-header';
    header.textContent = text;
    header.style.margin = '20px 0 10px 0';
    header.style.paddingLeft = '10px';
    header.style.borderLeft = '4px solid #3498db';
    return header;
}

function createNoResultsMessage() {
    const message = document.createElement('div');
    message.id = 'no-results-message';
    message.className = 'no-results';
    message.textContent = 'No matching results found. Try different search terms.';
    message.style.padding = '20px';
    message.style.textAlign = 'center';
    message.style.color = '#666';
    message.style.fontStyle = 'italic';
    return message;
}


function generateFilterButtons(filterType) {
    const filterMap = {
        brand: { contentType: 'documentationLink', dataField: 'brand', containerId: 'brandContainer' },
        type: { contentType: 'documentationLink', dataField: 'type', containerId: 'typeContainer' },
        category: { contentType: 'faq', dataField: 'category', containerId: 'faqCategoryContainer' },
        model: { contentType: 'faq', dataField: 'model', containerId: 'faqModelContainer' }
    };
    
    const filterConfig = filterMap[filterType];
    if (!filterConfig) return;
    
    const { contentType, dataField, containerId } = filterConfig;
    const container = document.getElementById(containerId);
    if (!container) return;
    
    container.innerHTML = '';
    
    const filterValues = new Set();
    
    allItems[contentType].forEach(item => {
        if (item.fields[dataField]) {
            if (Array.isArray(item.fields[dataField])) {
                item.fields[dataField].forEach(value => filterValues.add(value));
            } else {
                filterValues.add(item.fields[dataField]);
            }
        }
    });
    
    filterValues.forEach(value => {
        if (!value) return; // Skip empty values
        
        const button = document.createElement('div');
        button.classList.add('brandButton');
        button.innerText = value;
        button.addEventListener('click', () => {
            filterCards(value);
        });
        container.appendChild(button);
    });
}


function switchTab(tabName) {
    activeTab = tabName;

    document.getElementById("docTab").innerText = "Documentation";
    
    const searchInput = document.getElementById('search-input');
    const isSearchActive = searchInput.value.trim() !== '';
    
    if (isSearchActive) {
        const tabButtons = document.querySelectorAll('.section-button');
        tabButtons.forEach(button => {
            if (button.textContent.trim().toLowerCase().includes(tabName)) {
                button.classList.add('activeTab');
            } else {
                button.classList.remove('activeTab');
            }
        });
        return;
    }
    
    const tabButtons = document.querySelectorAll('.section-button');
    tabButtons.forEach(button => {
        if (button.textContent.trim().toLowerCase().includes(tabName)) {
            button.classList.add('activeTab');
        } else {
            button.classList.remove('activeTab');
        }
    });
    
    const documentationGrid = document.getElementById('documentationLink-grid');
    const faqGrid = document.getElementById('faq-grid');
    const iframeContainer = document.getElementById('documentation-iframe-container');
    
    iframeContainer.style.display = 'none';
    document.getElementById('documentation-iframe').src = '';
    
    const docResultsHeader = document.getElementById('doc-results-header');
    const faqResultsHeader = document.getElementById('faq-results-header');
    const noResultsMsg = document.getElementById('no-results-message');
    
    if (docResultsHeader) docResultsHeader.remove();
    if (faqResultsHeader) faqResultsHeader.remove();
    if (noResultsMsg) noResultsMsg.style.display = 'none';
    
    if (tabName === 'documentation') {
        documentationGrid.style.display = 'grid';
        faqGrid.style.display = 'none';
        
        document.getElementById('brandContainer').style.display = 'flex';
        document.getElementById('typeContainer').style.display = 'flex';
        document.getElementById('faqCategoryContainer').style.display = 'none';
        document.getElementById('faqModelContainer').style.display = 'none';
    } else {
        documentationGrid.style.display = 'none';
        faqGrid.style.display = 'grid';
        
        document.getElementById('brandContainer').style.display = 'none';
        document.getElementById('typeContainer').style.display = 'none';
        document.getElementById('faqCategoryContainer').style.display = 'flex';
        document.getElementById('faqModelContainer').style.display = 'flex';
    }
}


function initializeFaqUI() {
    const faqGrid = document.createElement('div');
    faqGrid.id = 'faq-grid';
    faqGrid.className = 'faq-grid';
    faqGrid.style.display = 'none'; 
    
    const faqCategoryContainer = document.createElement('div');
    faqCategoryContainer.id = 'faqCategoryContainer';
    faqCategoryContainer.className = 'search-container brandContainer flRow';
    faqCategoryContainer.style.display = 'none';
    
    const faqModelContainer = document.createElement('div');
    faqModelContainer.id = 'faqModelContainer';
    faqModelContainer.className = 'search-container brandContainer flRow';
    faqModelContainer.style.display = 'none';
    
    const documentationContainer = document.querySelector('.documentation-container');
    const typeButtons = document.getElementById('typeButtons');
    
    documentationContainer.insertBefore(faqCategoryContainer, typeButtons);
    documentationContainer.insertBefore(faqModelContainer, typeButtons);
    
    if (!document.getElementById('faq-grid')) {
        documentationContainer.appendChild(faqGrid);
    }
}


document.addEventListener('DOMContentLoaded', () => {
    initializeFaqUI();
    initializeArticleUI();
    
    const searchInput = document.getElementById('search-input');
    const searchContainer = searchInput.parentElement;
    const url = new URL(window.location.href);
    
    if (!document.getElementById('clear-search')) {
        const clearSearchButton = document.createElement('button');
        clearSearchButton.id = 'clear-search';
        clearSearchButton.innerHTML = 'Clear search';
        clearSearchButton.title = 'Clear search';
        clearSearchButton.style.position = 'absolute';
        clearSearchButton.style.right = '10px';
        clearSearchButton.style.top = '50%';
        clearSearchButton.style.transform = 'translateY(-50%)';
        clearSearchButton.style.background = '#00243ff7';
        clearSearchButton.style.color = "white";
        clearSearchButton.style.padding = "2px 10px";
        clearSearchButton.style.borderRadius = '4px';
        clearSearchButton.style.border = 'none';
        clearSearchButton.style.fontSize = '18px';
        clearSearchButton.style.cursor = 'pointer';
        clearSearchButton.style.display = 'none';
        
        searchContainer.style.position = 'relative';
        searchContainer.appendChild(clearSearchButton);
        
        clearSearchButton.addEventListener('click', () => {
            url.searchParams.delete("q");
            window.history.pushState({}, '', url);
            searchInput.value = '';
            clearSearchButton.style.display = 'none';
            document.getElementById('seenWarrantyContainer').innerHTML = '';
            displayContent('faq');
            displayContent('documentationLink');
            filterCards('');
        });
    }

    let dataLoadingStatus = {
        documentationLoaded: false,
        faqLoaded: false,
        urlParamProcessed: false
    };
    
    function checkDataAndProcessURL() {
        if (dataLoadingStatus.documentationLoaded && dataLoadingStatus.faqLoaded && !dataLoadingStatus.urlParamProcessed) {
            const searchParam = url.searchParams.get('q');
            if (searchParam) {
                dataLoadingStatus.urlParamProcessed = true;
                const clearButton = document.getElementById('clear-search');
                if (clearButton) {
                    clearButton.style.display = 'block';
                }
                searchInput.value = searchParam;
                
                filterCards(searchParam);
                
                const docTab = document.getElementById('docTab');
                const faqTab = document.getElementById('faqTab');
                if (docTab && faqTab) {
                    docTab.classList.add('activeTab');
                    faqTab.classList.remove('activeTab');
                }
            }
        }
    }
    
    async function loadDocumentationData() {
        try {
            const docGrid = document.getElementById('documentationLink-grid');
            docGrid.innerHTML = '<div class="loading">Loading documentation...</div>';
            
            const response = await getAllEntriesByType('documentationLink');
            
            if (response && response.items && response.items.length > 0) {
                allItems.documentationLink = response.items;
                docGrid.innerHTML = '';
                
                const initialLimit = 25;
                const totalItems = response.items.length;
                const needsShowMore = totalItems > initialLimit;
                
                let i = 0;
                response.items.slice(0, initialLimit).forEach(item => {
                    i++;
                    const card = createDocumentationCard(item, i);
                    if (card) {
                        docGrid.appendChild(card);
                    }
                });
                
                if (needsShowMore) {
                    addShowMoreButton(docGrid, 'doc', initialLimit, totalItems, response.items);
                }
                
                dataLoadingStatus.documentationLoaded = true;
                checkDataAndProcessURL();
            } else {
                docGrid.innerHTML = '<div class="error-message">No documentation items found.</div>';
                dataLoadingStatus.documentationLoaded = true;
                checkDataAndProcessURL();
            }
        } catch (error) {
            console.error('Failed to fetch documentation:', error);
            document.getElementById('documentationLink-grid').innerHTML = 
                '<div class="error-message">Failed to load documentation items. Please try again later.</div>';
            dataLoadingStatus.documentationLoaded = true;
            checkDataAndProcessURL();
        }
    }
    
    async function loadFaqData() {
        try {
            const faqGrid = document.getElementById('faq-grid');
            faqGrid.innerHTML = '<div class="loading">Loading FAQs...</div>';
            
            const response = await getAllEntriesByType('faq');
            
            if (response && response.items && response.items.length > 0) {
                allItems.faq = response.items;
                faqGrid.innerHTML = '';
                
                const initialLimit = 10;
                const totalItems = response.items.length;
                const needsShowMore = totalItems > initialLimit;
                
                let i = 0;
                response.items.slice(0, initialLimit).forEach(item => {
                    i++;
                    const card = createFaqCard(item, i);
                    if (card) {
                        faqGrid.appendChild(card);
                    }
                });
                
                if (needsShowMore) {
                    addShowMoreButton(faqGrid, 'faq', initialLimit, totalItems, response.items);
                }
                
                dataLoadingStatus.faqLoaded = true;
                checkDataAndProcessURL();
            } else {
                faqGrid.innerHTML = '<div class="error-message">No FAQ items found.</div>';
                dataLoadingStatus.faqLoaded = true;
                checkDataAndProcessURL();
            }
        } catch (error) {
            console.error('Failed to fetch FAQs:', error);
            document.getElementById('faq-grid').innerHTML = 
                '<div class="error-message">Failed to load FAQ items. Please try again later.</div>';
            dataLoadingStatus.faqLoaded = true;
            checkDataAndProcessURL();
        }
    }
    
    loadDocumentationData();
    loadFaqData();
    
    searchInput.addEventListener('input', (e) => {
        if (e.target.value !== "") {
            url.searchParams.set("q", e.target.value);
        } else {
            url.searchParams.delete("q");
        } 

        window.history.pushState({}, '', url);
        
        const clearButton = document.getElementById('clear-search');
        if (clearButton) {
            clearButton.style.display = e.target.value ? 'block' : 'none';
        }
        
        if (dataLoadingStatus.documentationLoaded && dataLoadingStatus.faqLoaded) {
            filterCards(e.target.value);
        } else {
            console.warn('Search attempted before data fully loaded');
        }
    });

    // Tab button event listeners
    const tabButtons = document.querySelectorAll('.section-button');
    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            const tabName = button.dataset.tabname;
            switchTab(tabName);
        });
    });
    
    // iframe controls
    const closeIframeButton = document.getElementById('close-iframe');
    closeIframeButton.addEventListener('click', () => {
        const iframeContainer = document.getElementById('documentation-iframe-container');
        const contentGrid = document.getElementById(`documentationLink-grid`);
        const sectionTitle = document.querySelector('.section-title.activeTab');
        
        iframeContainer.style.display = 'none';
        contentGrid.style.display = 'grid';
        
        if (activeTab === 'documentation') {
            sectionTitle.innerText = "Documentation Resources";
        } else {
            sectionTitle.innerText = "Frequently Asked Questions";
        }
        
        document.getElementById('documentation-iframe').src = '';
    });
    
    const openInNewPageButton = document.getElementById('open-iframe');
    openInNewPageButton.addEventListener('click', () => {
        window.open(openInNewPageButton.dataset.url, '_blank').focus();
    });
});


async function displayContent(contentType) {
    const grid = document.getElementById(`${contentType}-grid`);
    const noResultsMsg = document.getElementById('no-results-message');
    if (noResultsMsg) noResultsMsg.style.display = 'none';
    try {
        grid.innerHTML = '<div class="loading">Loading content...</div>';
        
        const response = await getAllEntriesByType(contentType);
        
        if (response && response.items && response.items.length > 0) {
            grid.innerHTML = '';
            allItems[contentType] = response.items;
            
            const initialLimit = 25;
            const totalItems = response.items.length;
            
            const needsShowMore = totalItems > initialLimit;
            
            let i = 0;
            response.items.slice(0, initialLimit).forEach(item => {
                i++;
                let card;
                
                if (contentType === 'documentationLink') {
                    card = createDocumentationCard(item, i);
                } else if (contentType === 'faq') {
                    card = createFaqCard(item, i);
                }
                
                if (card) {
                    grid.appendChild(card);
                }
            });
            
            if (needsShowMore) {
                const showMoreContainer = document.createElement('div');
                showMoreContainer.className = 'show-more-container';
                
                const showMoreButton = document.createElement('button');
                showMoreButton.className = 'show-more-button';
                showMoreButton.textContent = `Show More (${initialLimit} of ${totalItems})`;
                showMoreButton.dataset.currentShown = initialLimit;
                showMoreButton.dataset.contentType = contentType;
                showMoreButton.dataset.totalItems = totalItems;
                
                showMoreButton.addEventListener('click', handleShowMore);
                
                showMoreContainer.appendChild(showMoreButton);
                grid.appendChild(showMoreContainer);
            }
            
        } else {
            grid.innerHTML = `<div class="error-message">No ${contentType === 'documentationLink' ? 'documentation' : 'FAQ'} items found.</div>`;
        }
    } catch (error) {
        console.error(`Failed to fetch ${contentType}:`, error);
        grid.innerHTML = `<div class="error-message">Failed to load ${contentType === 'documentationLink' ? 'documentation' : 'FAQ'} items. Please try again later.</div>`;
    }
}

function handleShowMore(event) {
    const button = event.currentTarget;
    const contentType = button.dataset.contentType;
    const currentShown = parseInt(button.dataset.currentShown);
    const totalItems = parseInt(button.dataset.totalItems);
    
    const batchSize = 25;
    const nextBatch = Math.min(currentShown + batchSize, totalItems);
    
    const grid = document.getElementById(`${contentType}-grid`);
    
    const showMoreContainer = button.parentElement;
    grid.removeChild(showMoreContainer);
    
    let i = currentShown;
    allItems[contentType].slice(currentShown, nextBatch).forEach(item => {
        i++;
        let card;
        
        if (contentType === 'documentationLink') {
            card = createDocumentationCard(item, i);
        } else if (contentType === 'faq') {
            card = createFaqCard(item, i);
        }
        
        if (card) {
            grid.appendChild(card);
        }
    });
    
    button.dataset.currentShown = nextBatch;
    button.textContent = `Show More (${nextBatch} of ${totalItems})`;
    
    if (nextBatch < totalItems) {
        grid.appendChild(showMoreContainer);
    }
}
